import { t } from '@lingui/core/macro';
import { TMonthsFilterDateRange } from 'types';

export const getDateRangeLabel = (dateRangeId: string) =>
  DATE_RANGES().find((dateRange) => dateRange.id === dateRangeId)?.label;

export const DATE_RANGES = (): TMonthsFilterDateRange[] => [
  {
    id: '1 month',
    label: t`Last 1 month`,
  },
  {
    id: '3 months',
    label: t`Last 3 months`,
  },
  {
    id: '6 months',
    label: t`Last 6 months`,
  },
  {
    id: 'all months',
    label: t`All time`,
  },
];
